import axios from "axios";
import { API } from "./api";

const TOKEN_KEY = "sugandhi_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const adminLogin = (email, password) =>
  adminApi.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => adminApi.get("/auth/me").then((r) => r.data);
export const adminCreateProduct = (data) => adminApi.post("/admin/products", data).then((r) => r.data);
export const adminUpdateProduct = (id, data) => adminApi.put(`/admin/products/${id}`, data).then((r) => r.data);
export const adminDeleteProduct = (id) => adminApi.delete(`/admin/products/${id}`).then((r) => r.data);
export const adminUpdateHeroImages = (images) => adminApi.put(`/admin/hero-images`, { images }).then((r) => r.data);
export const adminListReviews = () => adminApi.get("/admin/reviews").then((r) => r.data);
export const adminCreateReview = (data) => adminApi.post("/admin/reviews", data).then((r) => r.data);
export const adminUpdateReview = (id, data) => adminApi.put(`/admin/reviews/${id}`, data).then((r) => r.data);
export const adminDeleteReview = (id) => adminApi.delete(`/admin/reviews/${id}`).then((r) => r.data);
export const adminCreateShipment = (orderId) => adminApi.post(`/admin/shipments/${orderId}`).then((r) => r.data);
export const adminSyncShipment = (orderId) => adminApi.post(`/admin/shipments/${orderId}/sync`).then((r) => r.data);
export const adminDeleteOrder = (id) => adminApi.delete(`/admin/orders/${id}`).then((r) => r.data);
export const adminUpdateCategory = (id, data) => adminApi.put(`/admin/categories/${id}`, data).then((r) => r.data);
export const adminListOrders = () => adminApi.get("/admin/orders").then((r) => r.data);
export const adminUpdateOrderStatus = (id, status) =>
  adminApi.put(`/admin/orders/${id}/status`, { status }).then((r) => r.data);
